import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import ModuleHeader from "../components/ModuleHeader";
import ReactEcharts from "echarts-for-react";
import { REM_CONFIG } from "@/utils/fontSize";
const KeyIndicators = ({ className = "", data: customData, }) => {
    // 默认模拟数据
    const defaultData = [
        {
            name: "榆林化工",
            businessIncome: 90,
            receivableCollection: 85,
            operatingProfit: 80,
        },
        {
            name: "包头化工",
            businessIncome: 88,
            receivableCollection: 83,
            operatingProfit: 82,
        },
        {
            name: "新疆化工",
            businessIncome: 95,
            receivableCollection: 92,
            operatingProfit: 90,
        },
        {
            name: "神木化工",
            businessIncome: 75,
            receivableCollection: 72,
            operatingProfit: 70,
        },
    ];
    // 确定最终使用的数据（优先使用外部传入的数据，若无则使用默认数据）
    const chartData = customData || defaultData;
    // 生成ECharts配置项
    const getEchartsOption = (data) => {
        const enterpriseNames = data.map((item) => item.name);
        return {
            tooltip: {
                trigger: "axis",
                axisPointer: { type: "shadow" },
                backgroundColor: "rgba(7, 31, 75, 0.8)",
                borderColor: "#446b9f",
                textStyle: {
                    color: "#fff",
                },
                formatter: function (params) {
                    let result = `${params[0].name}<br/>`;
                    params.forEach((param) => {
                        result += `${param.marker}${param.seriesName}: ${param.value}%<br/>`;
                    });
                    return result;
                },
            },
            legend: {
                data: ["营业收入", "应收款回款", "经营利润"],
                textStyle: { color: "#fff", fontSize: REM_CONFIG.fontSize.small },
                top: 4,
                right: "center",
                width: "100%",
                itemHeight: 6,
                itemWidth: 10,
            },
            grid: {
                left: "4%",
                right: "10%", // 增加右侧空间以显示100标签
                bottom: "2%",
                top: "15%",
                containLabel: true,
            },
            xAxis: {
                type: "value",
                max: 100,
                axisLabel: {
                    color: "#ccc",
                    show: false,
                },
                axisLine: {
                    lineStyle: { color: "rgba(255,255,255,0.1)" },
                },
                splitLine: {
                    lineStyle: { color: "rgba(255,255,255,0.05)" },
                },
            },
            yAxis: {
                type: "category",
                data: enterpriseNames,
                axisLabel: {
                    color: "#fff",
                    fontSize: REM_CONFIG.fontSize.small,
                },
                axisLine: {
                    lineStyle: { color: "rgba(255,255,255,0.1)" },
                },
                splitLine: {
                    lineStyle: { color: "rgba(255,255,255,0.05)" },
                },
            },
            series: [
                {
                    name: "营业收入",
                    type: "bar",
                    data: data.map((item) => item.businessIncome),
                    itemStyle: { color: "#ffc107" },
                    barWidth: 6,
                },
                {
                    name: "应收款回款",
                    type: "bar",
                    data: data.map((item) => item.receivableCollection),
                    itemStyle: { color: "#00FFFF" },
                    barWidth: 6,
                },
                {
                    name: "经营利润",
                    type: "bar",
                    data: data.map((item) => item.operatingProfit),
                    itemStyle: { color: "#42a5f5" },
                    barWidth: 6,
                },
                {
                    name: "参考线",
                    type: "bar",
                    data: data.map(() => 100),
                    barWidth: 0, // 设置为0宽度，不显示柱状图
                    label: {
                        show: true,
                        position: "right",
                        formatter: "100%",
                        color: "rgba(255, 255, 255, 0.7)",
                        fontSize: REM_CONFIG.fontSize.small,
                        fontWeight: "bold",
                        distance: 35,
                        verticalAlign: "top", // 垂直对齐方式为顶部
                        align: "right", // 水平对齐方式为右对齐
                        offset: [0, -15], // 向上偏移5像素
                    },
                },
            ],
        };
    };
    return (_jsxs("div", { className: `
        relative 
        bg-gradient-to-t 
        from-[rgba(7,31,75,0.5)] 
        to-[rgba(6,32,66,0.2)] 
        flex flex-col 
        min-h-0
        ${className}
      `, children: [_jsx(ModuleHeader, { title: "\u4E3B\u8981\u6307\u6807" }), _jsx("div", { className: "flex-1 w-full min-h-0 ", children: _jsx(ReactEcharts, { option: getEchartsOption(chartData), style: { width: "100%", height: "100%" } }) })] }));
};
export default KeyIndicators;
